import Proptypes from 'prop-types'

import { StyledSeparator } from './styles'

export const Separator = ({ length, themeInfos }) => <StyledSeparator $length={length} $themeCustom={themeInfos} />

Separator.propTypes = {
  length: Proptypes.any,
  themeInfos: Proptypes.object,
}

export default Separator
